import { useState } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { useTranslation } from '@mc/i18n'
import { Icon, Separator } from '@mc/design-system'

import Sticky from 'components/Sticky'

const QuizModal = dynamic(() => import('./QuizModal'), { ssr: false })

const StickyHeader = ({ shouldAutoOpenQuiz }) => {
  const { t } = useTranslation('@mc/next')

  const [isModalOpen, setIsModalOpen] = useState(shouldAutoOpenQuiz)

  return (
    <>
      <Sticky config={{ topBuffer: 400, bottomBuffer: 1 }} position='top'>
        <Separator className='mc-m-0 mc-opacity--muted' />
        <button
          className='container d-flex align-items-center justify-content-between mc-py-4 mc-tile--pointer'
          onClick={() => setIsModalOpen(true)}
          aria-labelledby='quiz-banner-title quiz-banner-description'
        >
          <div>
            <p className='mc-text--highlight mc-text-h6' id='quiz-banner-title'>
              {t('article.quiz.banner.title')}
            </p>
            <p className='mc-text-h6' id='quiz-banner-description'>
              {t('article.quiz.banner.description')}
            </p>
          </div>
          <div className='d-flex align-items-center'>
            <span className='d-none d-sm-block mc-text-h8 mc-text--uppercase mc-mr-3'>
              {t('article.quiz.banner.cta')}
            </span>
            <Icon
              kind='chevron-right'
              className='mc-bg-primary mc-corners--circle'
            />
          </div>
        </button>
      </Sticky>
      {isModalOpen && (
        <QuizModal
          onClose={() => setIsModalOpen(false)}
          showContinue={shouldAutoOpenQuiz}
        />
      )}
    </>
  )
}

StickyHeader.propTypes = {
  shouldAutoOpenQuiz: PropTypes.bool.isRequired,
}

export default StickyHeader
